import { BRANDS } from "../data/site";

export const Marquee = () => (
  <div className="marquee relative overflow-hidden" data-testid="brands-marquee-strip">
    <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-obsidian to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-obsidian to-transparent" />
    <div className="marquee-track flex w-max items-center py-2">
      {[...BRANDS, ...BRANDS].map((brand, i) => (
        <span key={i} className="flex items-center px-8 sm:px-10">
          <img
            src={brand.logo}
            alt={brand.name}
            loading="lazy"
            className="h-9 w-auto object-contain opacity-90 transition-opacity duration-300 hover:opacity-100 sm:h-11"
          />
        </span>
      ))}
    </div>
  </div>
);
